<template>
  <v-row class="fill-height align-start" style="background-color: #f6f8fa">
    <v-col cols="12" class="py-0" SPLASH>
      <v-card color="primary" flat tile dark>
        <v-card-text>
          <v-row class="text-center align-center py-12 my-12">
            <v-col cols="12" md="3"> </v-col>
            <v-col cols="12" md="6">
              <v-row class="text-center align-center">
                <v-col cols="12" md="12">
                  <div
                    :class="`${arabic ? 'arFont' : 'enFont'} white--text py-3`"
                    style="
                      line-height: 36px;
                      font-size: 2rem;
                      font-weight: bold;
                    "
                  >
                    {{ i18n["hero_promo_country_count"] }}
                  </div>
                </v-col>
                <v-col cols="12" md="12">
                  <div
                    :class="`${arabic ? 'arFont' : 'enFont'} white--text py-3`"
                    style="line-height: 1.6; font-size: 1.2rem"
                  >
                    {{ i18n["hero_country_arabic"] }}
                    <img src="/flags/sa.png" height="22px" />
                    {{ i18n["hero_country_kuwait"] }}

                    <img src="/flags/kw.png" height="22px" />
                    {{ i18n["hero_country_oman"] }}

                    <img src="/flags/om.png" height="22px" />
                    {{ i18n["hero_country_bahrain"] }}

                    <img src="/flags/bh.png" height="22px" />
                    {{ i18n["hero_country_iraq"] }}

                    <img src="/flags/iq.png" height="22px" />
                    {{ i18n["hero_country_alardn"] }}

                    <img src="/flags/jo.png" height="22px" />
                    {{ i18n["hero_country_lebya"] }}

                    <img src="/flags/ly.png" height="22px" />
                    {{ i18n["hero_country_felesteen"] }}

                    <img src="/flags/ps.png" height="22px" />
                    {{ i18n["hero_country_misr"] }}

                    <img src="/flags/eg.png" height="22px" />
                    {{ i18n["hero_country_emarat_arabia"] }}
                    <img src="/flags/ae.png" height="22px" />
                    {{ i18n["hero_country_qatar"] }}
                    <img src="/flags/qa.png" height="22px" />
                    {{ i18n["hero_country_lebnan"] }}
                    <img src="/flags/lb.png" height="22px" />
                    {{ i18n["hero_country_maghreb"] }}
                    <img src="/flags/ma.png" height="22px" />
                    {{ i18n["hero_country_sanghal"] }}
                    <img src="/flags/sn.png" height="22px" />
                    {{ i18n["hero_country_sahil"] }}
                    <img src="/flags/ci.png" height="22px" />
                  </div>
                </v-col>
                <v-col cols="12" md="12" v-if="false">
                  <video
                    width="100%"
                    controls
                    :poster="`/images/${language}.jpg`"
                    style="object-fit: cover; background-size: 100% auto"
                  >
                    <source
                      src="https://firebasestorage.googleapis.com/v0/b/ashyaatcrm.appspot.com/o/ninjavid%2FNinja%20Sellers%2002%204K.mp4?alt=media&token=ba49ef30-8f05-4062-bc07-22640f5ac012"
                      type="video/mp4"
                    />
                    <img
                      :src="`/images/${language}.jpg`"
                      title="Your browser does not support the <video> tag"
                    />
                  </video>
                </v-col>
                <v-col cols="12" md="12">
                  <img
                    :src="`/images/${language}.jpg`"
                    width="100%"
                    @click="videoDialog = true"
                    style="cursor: pointer"
                  />
                  <v-dialog v-model="videoDialog" persistent max-width="800">
                    <v-card>
                      <iframe
                        width="100%"
                        height="315"
                        :src="youtube_video[language]"
                        title="ninjasellers.com"
                        frameborder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowfullscreen
                      ></iframe>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          @click.native="videoDialog = false"
                          :class="`${arabic ? 'arFont' : 'enFont'}`"
                          >{{ i18n["close"] }}</v-btn
                        >
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-col>
                <v-col cols="12" md="12">
                  <v-btn
                    outlined
                    v-if="false"
                    x-large
                    rounded
                    @click="videoDialog = true"
                    color="white"
                    :class="`${
                      arabic ? 'arFont' : 'enFont'
                    } white--text px-8 mx-2`"
                  >
                    <v-icon>play_circle_outline</v-icon>
                  </v-btn>

                  <v-btn
                    outlined
                    x-large
                    rounded
                    @click="signup()"
                    color="white"
                    :class="`${arabic ? 'arFont' : 'enFont'} white--text px-8`"
                  >
                    {{ i18n.start }}
                  </v-btn>
                </v-col>
                <v-col cols="12" md="12">
                  <div
                    :class="`${arabic ? 'arFont' : 'enFont'} white--text py-3`"
                    style="
                      line-height: 1.6;
                      font-size: 1.4rem;
                      font-weight: bold;
                    "
                  >
                    {{ i18n["partner_dream_ecommerce"] }}
                  </div>
                </v-col>
                <v-col cols="12" md="6">
                  <a href="https://academy.ninjasellers.com/">
                    <img
                      src="/images/ninja-academy-logo-english-white.png"
                      alt="ninja academy"
                      width="180px"
                    />
                  </a>
                </v-col>
                <v-col cols="12" md="6">
                  <div></div>
                  <div
                    :class="`${arabic ? 'arFont' : 'enFont'} white--text py-3`"
                    style="
                      line-height: 1.6;
                      font-size: 1.2rem;
                      text-decoration: unset;
                    "
                  >
                    <a
                      href="https://academy.ninjasellers.com/"
                      style="color: white; text-decoration: unset"
                    >
                      {{ i18n["ninja_seller_academy"] }}
                      <span
                        style="text-decoration: underline;font-weight: bold;color: #ffbf23;"
                        >{{ i18n["free"] }}</span
                      >
                    </a>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="3"> </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" class="py-0" WHYUS>
      <v-card color="" flat tile class="py-5">
        <v-card-text class="fill-height">
          <v-row class="text-center align-center">
            <v-col cols="12" md="6">
              <img src="/images/home/why_ninja_sellers.png" width="70%" />
            </v-col>
            <v-col cols="12" md="6">
              <v-row class="text-start align-center px-2">
                <v-col cols="12" md="12">
                  <h2
                    :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                    style="
                      line-height: 1.6;
                      color: #000;
                      text-decoration: underline 0.7rem solid #000;
                    "
                  >
                    {{ i18n["ninja_seller_offer"] }}
                  </h2>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                  style="color: #000; font-size: 1.1rem"
                >
                  {{ i18n["ninja_seller_offer_detail"] }}
                </v-col>
                <v-col cols="12" md="12">
                  <h2
                    :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                    style="
                      line-height: 1.6;
                      color: #000;
                      text-decoration: underline 0.7rem solid #000;
                    "
                  >
                    {{ i18n["why_ninja_seller"] }}
                  </h2>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                  style="color: #000; font-size: 1.1rem"
                  v-html="i18n['why_ninja_seller_description']"
                >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" class="py-0" FEATURE CARDS>
      <v-card color="#fff" flat tile class="py-7 px-8">
        <v-card-text class="fill-height">
          <v-row class="text-center align-center">
            <v-col cols="12">
              <div
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                style="
                  color: #000;
                  line-height: 36px;
                  font-size: 2rem;
                  font-weight: bold;
                "
              >
                {{ i18n["project_starting_title"] }}
              </div>
            </v-col>
            <v-col cols="12">
              <div
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                style="line-height: 1.6; font-size: 1.2rem"
              >
                {{ i18n["project_starting_description"] }}
              </div>
            </v-col>
            <v-col cols="12" md="3" class="px-5" FEATURE>
              <v-row class="text-center align-center">
                <v-col cols="12" md="12">
                  <img src="/images/home/project_marketting_product.png" width="50%" />
                </v-col>
                <v-col cols="12" md="12">
                  <h3
                    :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                    style="color: #000"
                  >
                    {{ i18n["project_marketting_product"] }}
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                  style="color: #000"
                  >{{ i18n["project_marketting_description"] }}
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="3" class="px-5" FEATURE>
              <v-row class="text-center align-center">
                <v-col cols="12" md="12">
                  <img src="/images/home/project_wihtout_capital.png" width="50%" />
                </v-col>
                <v-col cols="12" md="12">
                  <h3
                    :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                    style="color: #000"
                  >
                    {{ i18n["project_wihtout_capital"] }}
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                  style="color: #000"
                >
                  {{ i18n["project_capital_decription"] }}
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="3" class="px-5" FEATURE>
              <v-row class="text-center align-center">
                <v-col cols="12" md="12">
                  <img src="/images/home/project_net_profit.png" width="50%" />
                </v-col>
                <v-col cols="12" md="12">
                  <h3
                    :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                    style="color: #000"
                  >
                    {{ i18n["project_net_profit"] }}
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                  style="color: #000"
                >
                  {{ i18n["project_profit_decription"] }}
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="3" class="px-5" FEATURE>
              <v-row class="text-center align-center">
                <v-col cols="12" md="12">
                  <img src="/images/home/project_step_ecommerce.png" width="50%" />
                </v-col>
                <v-col cols="12" md="12">
                  <h3
                    :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                    style="color: #000"
                  >
                    {{ i18n["project_step_ecommerce"] }}
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                  style="color: #000"
                >
                  {{ i18n["project_step_ecommerce_descr"] }}
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" class="py-5" BANNER>
      <img src="/images/home/Banner-For-Website.png" width="100%" alt="ninja sellers services">
    </v-col>
    <v-col cols="12" class="py-2" FEATURE CARDS>
      <v-card color="#fff" flat tile class="py-7 px-8">
        <v-card-text class="fill-height">
          <v-row class="text-center align-center">
            <v-col cols="12">
              <div
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                style="color: #000;
                  line-height: 36px;
                  font-size: 2rem;
                  font-weight: bold;
                "
              >
                {{ i18n["service_section_title"] }}
              </div>
            </v-col>
            <v-col cols="12">
              <div
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                style="line-height: 1.6; font-size: 1.2rem"
              >
                {{ i18n["service_section_sub_title"] }}
              </div>
            </v-col>
            <v-col cols="12" md="1" class="px-5" FEATURE>
            </v-col>
            <v-col cols="12" md="2" class="px-5" FEATURE>
              <v-row class="text-center align-center">
                <v-col cols="12" md="12">
                  <img src="/images/home/china.png" width="80%" />
                </v-col>
                <v-col cols="12" md="12">
                  <h3
                    :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                    style="color: #000"
                  >
                    {{ i18n["service_import_from_china"] }}
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                  style="color: #000"
                  >{{ i18n["service_import_from_china_description"] }}
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="2" class="px-5" FEATURE>
              <v-row class="text-center align-center">
                <v-col cols="12" md="12">
                  <img src="/images/home/service_store_import_orders.png" width="80%" />
                </v-col>
                <v-col cols="12" md="12">
                  <h3
                    :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                    style="color: #000"
                  >
                    {{ i18n["service_store_import_orders"] }}
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                  style="color: #000"
                >
                  {{ i18n["service_store_import_orders_decription"] }}
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="2" class="px-5" FEATURE>
              <v-row class="text-center align-center">
                <v-col cols="12" md="12">
                  <img src="/images/home/service_confirm_orders.png" width="80%" />
                </v-col>
                <v-col cols="12" md="12">
                  <h3
                    :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                    style="color: #000"
                  >
                    {{ i18n["service_confirm_orders"] }}
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                  style="color: #000"
                >
                  {{ i18n["service_confirm_orders_decription"] }}
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="2" class="px-5" FEATURE>
              <v-row class="text-center align-center">
                <v-col cols="12" md="12">
                  <img src="/images/home/service_local_delivery.png" width="80%" />
                </v-col>
                <v-col cols="12" md="12">
                  <h3
                    :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                    style="color: #000"
                  >
                    {{ i18n["service_local_delivery"] }}
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                  style="color: #000"
                >
                  {{ i18n["service_local_delivery_decription"] }}
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="2" class="px-5" FEATURE>
              <v-row class="text-center align-center">
                <v-col cols="12" md="12">
                  <img src="/images/home/service_cash_on_delivery.png" width="80%" />
                </v-col>
                <v-col cols="12" md="12">
                  <h3
                    :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                    style="color: #000"
                  >
                    {{ i18n["service_cash_on_delivery"] }}
                  </h3>
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                  :class="`${arabic ? 'arFont' : 'enFont'} py-3`"
                  style="color: #000"
                >
                  {{ i18n["service_cash_on_delivery_description"] }}
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="1" class="px-5" FEATURE>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" class="py-0" STEPS>
      <v-card color="#f0f0f0" flat tile class="py-5 px-5">
        <v-card-text class="fill-height">
          <v-row class="text-center align-center">
            <v-col cols="12">
              <div
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                style="color: #000;
                  line-height: 36px;
                  font-size: 2rem;
                  font-weight: bold;
                "
              >
                {{ i18n["ninja_seller_start_now"] }}
              </div>
            </v-col>
            <v-col cols="12" class="mb-5 text-center">
              <div
                :class="`${arabic ? 'arFont' : 'enFont'}`"
                style="line-height: 1.6; font-size: 1.2rem"
              >
                {{ i18n["ninja_how_web_work"] }}
              </div>
            </v-col>
            <v-col cols="12" md="3" class="px-5" STEP>
              <v-card style="min-height: 310px">
                <v-card color="primary" class="text-center" dark flat tile>
                  <v-avatar size="30" color="secondary">
                    <span style="font-size: 20px">1</span>
                  </v-avatar>
                </v-card>
                <v-row class="text-center align-center py-3 px-5">
                  <v-col cols="12" md="12">
                    <img src="/images/home/ninja_creat_account.png" width="60%" />
                  </v-col>
                  <v-col cols="12" md="12">
                    <h3
                      :class="`${arabic ? 'arFont' : 'enFont'} py-1`"
                      style="color: #000"
                    >
                      {{ i18n["ninja_creat_account"] }}
                    </h3>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col cols="12" md="3" class="px-5" STEP>
              <v-card style="min-height: 310px">
                <v-card color="primary" class="text-center" dark flat tile>
                  <v-avatar size="30" color="secondary">
                    <span style="font-size: 20px">2</span>
                  </v-avatar>
                </v-card>
                <v-row class="text-center align-center py-3 px-5">
                  <v-col cols="12" md="12">
                    <img src="/images/home/ninja_select_country_product.png" width="50%" />
                  </v-col>
                  <v-col cols="12" md="12">
                    <h3
                      :class="`${arabic ? 'arFont' : 'enFont'} py-1`"
                      style="color: #000"
                    >
                      {{ i18n["ninja_select_country_product"] }}
                    </h3>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" md="3" class="px-5" STEP>
              <v-card style="min-height: 310px">
                <v-card color="primary" class="text-center" dark flat tile>
                  <v-avatar size="30" color="secondary">
                    <span style="font-size: 20px">3</span>
                  </v-avatar>
                </v-card>
                <v-row class="text-center align-center py-3 px-5">
                  <v-col cols="12" md="12">
                    <img src="/images/home/ninja_fill_order.png" width="50%" />
                  </v-col>
                  <v-col cols="12" md="12">
                    <h3
                      :class="`${arabic ? 'arFont' : 'enFont'} py-1`"
                      style="color: #000"
                    >
                      {{ i18n["ninja_fill_order"] }}
                    </h3>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col cols="12" md="3" class="px-5" STEP>
              <v-card style="min-height: 310px">
                <v-card color="primary" class="text-center" dark flat tile>
                  <v-avatar size="30" color="secondary">
                    <span style="font-size: 20px">4</span>
                  </v-avatar>
                </v-card>
                <v-row class="text-center align-center py-3 px-5">
                  <v-col cols="12" md="12">
                    <img src="/images/home/ninja_transfered_amount.png" width="50%" />
                  </v-col>
                  <v-col cols="12" md="12">
                    <h3
                      :class="`${arabic ? 'arFont' : 'enFont'} py-1`"
                      style="color: #000"
                    >
                      {{ i18n["ninja_transfered_amount"] }}
                    </h3>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12" class="py-0" SPLASH>
      <v-card color="primary lighten-2" class="customPattern" flat tile dark>
        <v-card-text>
          <v-row class="text-center align-center py-12">
            <v-col cols="12" md="4"> </v-col>
            <v-col cols="12" md="4">
              <v-row class="text-center align-center">
                <v-col cols="12" md="12">
                  <h1
                    :class="`${arabic ? 'arFont' : 'enFont'} white--text py-3`"
                    style="line-height: 1.6"
                  >
                    {{ i18n["ninja_waiting_for_title"] }}
                  </h1>
                </v-col>
                <v-col cols="12" md="12">
                  <h2
                    :class="`${arabic ? 'arFont' : 'enFont'} white--text py-3`"
                    style="line-height: 1.6"
                  >
                    {{ i18n["ninja_waiting_for_description"] }}
                  </h2>
                </v-col>
                <v-col cols="12" md="12">
                  <v-btn
                    outlined
                    x-large
                    rounded
                    @click="signup()"
                    color="white"
                    :class="`${arabic ? 'arFont' : 'enFont'} white--text px-8`"
                  >
                    {{ i18n.start }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="4"> </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {
  getRandomInt,
  randomString,
  getCDate,
  check,
  sleep,
} from "@/customFunction";
import { format, render, cancel, register } from "timeago.js";
import Footer from "@/components/footer";
export default {
  components: {
    Footer,
  }, //multiDialog
  data() {
    return {
      loading: false,
      dialog: false,
      videoDialog: false,
      dnotification: null,
      videoDialog: false,
      youtube_video:{
        ar:'https://www.youtube.com/embed/xKrfBP-YKNE?si=xyO5TgHjGd8lZakE',
        en:'https://www.youtube.com/embed/lf0Ni7G2rJs?si=3w2TruG91gTLm3fK'
      }
    };
  },

  methods: {
    signup() {
      this.goTo("/register");
    },
    login() {
      this.goTo("/login");
    },
    goTo(path) {
      this.$router.push(path);
    },
  },
  watch: {},
  computed: {
    site() {
      return this.$store.state.site;
    },
    items() {
      return this.$store.state.menu;
    },
    superAdmin() {
      return this.$store.state.superAdmin;
    },
    isLogin() {
      return this.$store.state.centralLogin;
    },
    language() {
      return this.$store.state.language;
    },
    globalLoading() {
      return this.$store.state.globalLoading;
    },
    user() {
      return this.$store.state.user;
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
    routeTitle() {
      let main = this.$store.state.menu.filter(
        (x) => x.path == this.$route.path
      );
      let sub = []
        .concat(...this.$store.state.menu.map((x) => x.subs))
        .filter((x) => x)
        .filter((x) => x.path == this.$route.path);
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text];
      } else if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text];
      } else {
        return "";
      }
    },
    goalModel() {
      return this.$store.state.goalModel;
    },
    keyResultModel() {
      return this.$store.state.keyResultModel;
    },
    initModel() {
      return this.$store.state.initiativeModel;
    },
    units() {
      return this.$store.state.units;
    },
    quarters() {
      return this.$store.state.quarters;
    },
    fileTypes() {
      return this.$store.state.fileTypes;
    },
    notifications() {
      return this.$store.state.notifications.sort(
        (a, b) => b.timestamp - a.timestamp
      );
    },
  },
  async created() {},
};
</script>

<style>
.customPattern:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  background-image: url("/backsection.png");
  background-repeat: repeat;
  height: 100%;
  background-size: 40rem;
  opacity: 0.15;
}
</style>
